import { useState } from 'react';
import PageHeader from '../../components/common/PageHeader';
import Pill from '../../components/common/Pill';
import { useAuth } from '../../contexts/AuthContext';
import { extrairMensagemErro } from '../../components/common/ErroCarregamento';
import { labelPerfil, PERFIL_OPCOES } from '../../utils/webhookOpcoes';

export default function Perfil() {
  const { user, atualizarUsuario, alterarSenha } = useAuth();
  const [nome, setNome] = useState(user?.nome || '');
  const [mensagem, setMensagem] = useState(null);
  const [senhaAtual, setSenhaAtual] = useState('');
  const [novaSenha, setNovaSenha] = useState('');
  const [mensagemSenha, setMensagemSenha] = useState(null);

  const salvarNome = async (e) => {
    e.preventDefault();
    setMensagem(null);
    try {
      await atualizarUsuario({ nome });
      setMensagem({ ok: true, texto: 'Perfil atualizado.' });
    } catch (err) {
      setMensagem({ ok: false, texto: extrairMensagemErro(err, 'Não foi possível salvar.') });
    }
  };

  const salvarSenha = async (e) => {
    e.preventDefault();
    setMensagemSenha(null);
    try {
      await alterarSenha(senhaAtual, novaSenha);
      setSenhaAtual('');
      setNovaSenha('');
      setMensagemSenha({ ok: true, texto: 'Senha alterada. As outras sessões foram encerradas.' });
    } catch (err) {
      setMensagemSenha({ ok: false, texto: extrairMensagemErro(err, 'Não foi possível alterar a senha.') });
    }
  };

  return (
    <div>
      <PageHeader titulo="Meu perfil" subtitulo={user?.email} />

      <div className="row g-3">
        <div className="col-12 col-lg-6">
          <div className="card-soft">
            <div className="card-soft__header">
              <h2 className="card-soft__title">Dados</h2>
              <Pill tone="dark">{labelPerfil(user?.perfil)}</Pill>
            </div>
            <div className="card-soft__body">
              <form onSubmit={salvarNome}>
                <div className="mb-3">
                  <label className="wh-label">Nome</label>
                  <input className="wh-input" value={nome} onChange={(e) => setNome(e.target.value)} required />
                </div>
                <div className="mb-3">
                  <label className="wh-label">E-mail</label>
                  <input className="wh-input" value={user?.email || ''} disabled />
                  <div className="wh-hint">O e-mail é a identidade de login — a troca passa por um operador.</div>
                </div>
                <div className="wh-hint mb-3">
                  {PERFIL_OPCOES.find((p) => p.value === user?.perfil)?.descricao}
                </div>
                {mensagem && (
                  <div className={`alert ${mensagem.ok ? 'alert-success' : 'alert-danger'} py-2 px-3`} style={{ fontSize: 13 }}>
                    {mensagem.texto}
                  </div>
                )}
                <button type="submit" className="wh-btn wh-btn-primary">
                  Salvar
                </button>
              </form>
            </div>
          </div>
        </div>

        <div className="col-12 col-lg-6">
          <div className="card-soft">
            <div className="card-soft__header">
              <h2 className="card-soft__title">Alterar senha</h2>
            </div>
            <div className="card-soft__body">
              <form onSubmit={salvarSenha}>
                <div className="mb-3">
                  <label className="wh-label">Senha atual</label>
                  <input
                    type="password"
                    className="wh-input"
                    value={senhaAtual}
                    onChange={(e) => setSenhaAtual(e.target.value)}
                    autoComplete="current-password"
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="wh-label">Nova senha</label>
                  <input
                    type="password"
                    className="wh-input"
                    value={novaSenha}
                    onChange={(e) => setNovaSenha(e.target.value)}
                    autoComplete="new-password"
                    minLength={8}
                    required
                  />
                  <div className="wh-hint">Mínimo de 8 caracteres.</div>
                </div>
                {mensagemSenha && (
                  <div
                    className={`alert ${mensagemSenha.ok ? 'alert-success' : 'alert-danger'} py-2 px-3`}
                    style={{ fontSize: 13 }}
                  >
                    {mensagemSenha.texto}
                  </div>
                )}
                <button type="submit" className="wh-btn wh-btn-primary">
                  Alterar senha
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
